import React, { useContext, useState } from 'react';
import { Button, ButtonVariant, useFlashMessage } from '@indigo-ag/component-module';
import { AgFinancingInput, AgFinancingPhase2Status } from '@indigo-ag/schema';
import { useMutation } from '@apollo/client';

import i18next from 'core/i18n';
import { upsertFinancingAgFinancing } from 'features/brazil-grower/queries';
import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import {
  DecisionModal,
  DecisionModalProps
} from 'features/brazil-grower/components/BrazilGrowerFinance/shared/DecisionModal/DecisionModal';

interface UpdatePhase2StatusButtonDecisionModalProps {
  phase2TargetStatus: AgFinancingPhase2Status;
  modalTitle: DecisionModalProps['title'];
  buttonVariant: ButtonVariant;
  buttonText: string;
  onSuccessMessage: string;
}

export const UpdatePhase2StatusButtonDecisionModal: React.FunctionComponent<UpdatePhase2StatusButtonDecisionModalProps> = ({
  phase2TargetStatus,
  modalTitle,
  buttonVariant,
  buttonText,
  onSuccessMessage
}) => {
  /**
   * State
   */
  const [isDecisionOpen, setIsDecisionOpen] = useState(false);

  /**
   * Mutations
   */
  const [upsertFinancingAgFinancingFn] = useMutation(upsertFinancingAgFinancing);

  /**
   * Context
   */
  const { agFinance } = useContext(FinanceProcessContext);

  const { addFlashMessage } = useFlashMessage();

  const updatePhase2Status = (decisionNotes: string) => {
    const newAgFinancingData: Partial<AgFinancingInput> = {
      id: agFinance?.id,
      phase2: {
        status: phase2TargetStatus,
        decisionNotes
      }
    };

    return upsertFinancingAgFinancingFn({
      variables: {
        data: newAgFinancingData
      }
    })
      .then(() => {
        addFlashMessage({
          content: '',
          title: onSuccessMessage,
          variant: 'success'
        });
      })
      .catch(() => {
        addFlashMessage({
          content: i18next.t('error'),
          title: '',
          variant: 'error'
        });
      });
  };

  return (
    <>
      <DecisionModal
        title={modalTitle}
        onConfirmAction={updatePhase2Status}
        open={isDecisionOpen}
        closeModal={() => setIsDecisionOpen(false)}
        notesRequired
      />
      <Button
        variant={buttonVariant}
        size="small"
        onClick={() => setIsDecisionOpen(true)}
        className="text-transform-capitalize"
      >
        {buttonText}
      </Button>
    </>
  );
};
